import React, { useState } from "react";

import { useTranslations } from "../../contexts/translationContext";
import { StringWithFormat } from "../../types/Result";

export interface FormHeaderProps {
    title?: string | StringWithFormat,
    headerElement?: React.ReactElement,
    children?: any
}

const FormHeader: React.FC<FormHeaderProps> = ({ title, children, headerElement }) => {
    const [formTitle, setTitle] = useState<string | React.ReactElement>('');
    const { translate } = useTranslations();

    if (title) {
        if (typeof title === 'string') {
            translate(title, undefined, title).then(translated => setTitle(translated));
        } else {
            translate(title.format, undefined, title).then(translated => setTitle(translated));
        }
    }

    const dividerStyle: React.CSSProperties = { width: '10%', height: 5, margin: '-6px 0 10px 15px', backgroundColor: '#23ccef', display: 'block' };
    const titleStyle: React.CSSProperties = { float: 'left', margin: 0 }
    const actionButtonsStyle: React.CSSProperties = { float: 'right' }

    return (
        <>
            <div className="header">
                <h4 style={titleStyle}>{formTitle}</h4>
                {headerElement}
                <div style={actionButtonsStyle}>
                    {children}
                </div>
            </div>
            {formTitle && <div style={dividerStyle} />}
        </>
    );
}
export default FormHeader;